import { BaseError } from './base';

export class InvalidDeviceRegistrationRedirectError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'invalid_device_registration_redirect_error',
      docsUrl: null,
      metaMessages: [
        'To check if a URL is a valid device registration redirect before extracting the token, use detectDeviceRegistrationRedirect from the @dynamic-labs-sdk/client package.',
      ],
      name: 'InvalidDeviceRegistrationRedirectError',
      shortMessage:
        'The provided URL is not a valid device registration redirect.',
    });
  }
}
